export default __webpack_public_path__ + "images/OP.4c5585c.png";